import { Action } from 'redux';
import { IProfile } from '../../services';

export interface IProfileState {
  loading?: boolean;
  profile: IProfile | undefined;
  exceptionMessage?: string;
  message?: string;
}

export enum ProfileActionEnum {
  FetchProfile = '@@Profile/FETCH_Profile',
  FetchProfileSuccess = '@@Profile/FETCH_Profile_SUCCESS',
  FetchProfileFailed = '@@Profile/FETCH_Profile_FAILED'
}

export interface IFetchProfileAction
    extends Action<typeof ProfileActionEnum.FetchProfile> {
    state?: IProfileState;
}

export interface IFetchProfileSuccessAction
    extends Action<typeof ProfileActionEnum.FetchProfileSuccess> {
    state?: IProfileState;
}

export interface IFetchProfileFailedAction
    extends Action<typeof ProfileActionEnum.FetchProfileFailed> {
    state?: IProfileState;
}

export type ProfileActions =
  | IFetchProfileAction
  | IFetchProfileSuccessAction
  | IFetchProfileFailedAction

